import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getListingAgProductsAsync,
  getAgProductColumnsAsync,
} from 'src/redux/actions/omsProductActions'

type AgColumn = {
  field: string
  headerName: string
  allow_visiblity?: string
  advance_option?: {
    allow_sorting?: boolean
    allow_resize?: boolean
    allow_filter?: boolean
    filter_operators?: string[]
    filter_input_type?: string
    filter_options?: Array<{ label: string; value: any }>
  }
  field_type?: string
}

type AgRow = Record<string, any>

interface OmsGroupedLiteState {
  products: {
    rows: AgRow[]
    columns: AgColumn[]
    total: number
    loading: boolean
    error: string | null
  }
  productColumns: {
    columns: AgColumn[]
    loading: boolean
    error: string | null
  }
}

const initialState: OmsGroupedLiteState = {
  products: {
    rows: [],
    columns: [],
    total: 0,
    loading: false,
    error: null,
  },
  productColumns: {
    columns: [],
    loading: false,
    error: null,
  },
}

const getErrorMessage = (action: any) =>
  action?.payload?.message ||
  action?.payload?.data?.message ||
  action?.error?.message ||
  'Something went wrong'

const groupedViewLiteSlice = createSlice({
  name: 'omsGroupedLite',
  initialState,
  reducers: {
    resetOmsGroupedLiteState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListingAgProductsAsync.pending, (state) => {
        state.products.loading = true
        state.products.error = null
      })
      .addCase(getListingAgProductsAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.products.loading = false
        state.products.error = null

        const payload = action?.payload ||
          action.payload?.data?.data ||
          action.payload?.data || {}

        state.products.rows = payload.rows || []
        state.products.columns = payload.columns || []
        state.products.total = payload.total || 0
      })
      .addCase(getListingAgProductsAsync.rejected, (state, action) => {
        state.products.loading = false
        state.products.error = getErrorMessage(action)
      })

      .addCase(getAgProductColumnsAsync.pending, (state) => {
        state.productColumns.loading = true
        state.productColumns.error = null
      })
      .addCase(getAgProductColumnsAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.productColumns.loading = false
        state.productColumns.error = null
        state.productColumns.columns = action.payload?.columns || action.payload || []
      })
      .addCase(getAgProductColumnsAsync.rejected, (state, action) => {
        state.productColumns.loading = false
        state.productColumns.error = getErrorMessage(action)
      })
  },
})

export const { resetOmsGroupedLiteState } = groupedViewLiteSlice.actions
export default groupedViewLiteSlice.reducer